/**
 * The place where most of the custom JavaScript should be found.
 */

/**
 * Add a light dismiss to all dialogs.
 */
( () => {
    const dialogs = document.querySelectorAll( 'dialog.image-gallery-dialog' )

    if ( !dialogs ) {
        return
    }

    dialogs.forEach( dialog => {
        dialog.addEventListener( 'click', event => {
            event.preventDefault()

            if ( dialog.nodeName === 'DIALOG' ) {
                dialog.close( 'dismiss' )
            }
        })
    })
})();